import * as React from 'react'
import { connect } from 'react-redux'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PurchaseButton, ButtonProps } from '@amzn/dvui/dist/Button'
import { Text } from '@amzn/dvui/dist/Text'
import { sanitizedRequestContextSelector } from '../../selectors/requestContext'
import { IDetailPageState } from '../../reducers'
import * as utilityClasses from '../utilityClasses.module.scss'
import { ModalTrigger } from '@shared/utils/modalTrigger/ModalTrigger'
import { MoreWaysToSubscribeModal } from './moreWaysToWatchModal'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as cn from 'classnames'
import * as st from './acquisition.module.scss'

type IMoreSubscriptionOptions = {
  svodWinners: WpsRuntime.atv.wps.SubscribeActionTreeRightProps
  titleId?: string
  forceDoubleHeight: boolean
} & ReturnType<typeof mapStateToProps> & AtfTreatmentProps

const CSRMoreSubscriptionOptionsButton = ({
  svodWinners,
  forceDoubleHeight,
  atfTreatment
}: IMoreSubscriptionOptions) => {

  const label = svodWinners.metadata && svodWinners.metadata.label

  const atfTreatmentProps: ButtonProps = {
    ...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && { forceDoubleHeight: false }),
    ...(isTreatment(atfTreatment,'T1', 'T3') && { shape: 'pill' })
  }

  return (
    <ModalTrigger
      modalId='dvui-close-overlay-mwts'
      modalContent={<MoreWaysToSubscribeModal svodWinners={svodWinners} />}
      toggle={
        ({ openModalClickHandler }) => (
          <PurchaseButton
            data-ux-click
            onClick={openModalClickHandler}
            className={cn(utilityClasses.fullWidthPhablet, 'more-subscription-options-button', {[st.centerButton]: isTreatment(atfTreatment, 'T1', 'T2', 'T3')})}
            forceDoubleHeight={forceDoubleHeight}
            {...atfTreatmentProps}
          >
            <Text string={label} />
          </PurchaseButton>
        )
      } />

  )
}

const mapStateToProps = (state: IDetailPageState) => ({
  requestContext: sanitizedRequestContextSelector(state),
})

export const MoreSubscriptionOptionsButton = connect(mapStateToProps)(
  CSRMoreSubscriptionOptionsButton
)
